// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1v8qa","placeholdersHeader":"styles_placeholdersHeader__3qE3A","editorStyle":"styles_editorStyle__1CrEi","placeholdersBox":"styles_placeholdersBox__2BvOP"};